export enum HotelCategoryKey {
    ONE_STAR = '1',
    TWO_STARS = '2',
    THREE_STARS = '3',
    FOUR_STARS = '4',
    FIVE_STARS = '5',
    SIX_STARS = '12',
    APARTMENT = '13',
    ONE_KEY = '19',
    TWO_KEYS = '20',
    THREE_KEYS = '21',
    FOUR_KEYS = '22',
    FIVE_KEYS = '23',
    TWO_HALF_STARS = '25',
    THREE_HALF_STARS = '3.5',
}
